import React from "react";

import { TabProps } from "./Tabs.types";

export const Tab: React.FC<TabProps> = () => null;
